import { Button, Checkbox, Col, Form, Input, Popover, Radio, Row, Space, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { DateSelector } from "./DateSelector/web";
import { Grid } from "antd";
import { LeadButtons } from "../LeadButtons/web";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Rule } from "antd/lib/form";
import cookie from "js-cookie";
import { openAuthModal } from "../../../../Components/User/AuthModal/openAuthModal";
import { useContact } from "../hook";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
// import { useGoogleAnalytics } from "../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";
import { useUser } from "../../../User/User.hook";
import dayjs from "dayjs";
import getConfig from "next/config";
import IcBuscaPorTi from "shared-components/Components/PopUps/IcBuscaPorTi/web";
import { useCreateSearchAlert } from "shared-components/Components/SearchAlert/CreateSearchAlert/hook";
import { QuestionIcon } from "shared-components/Components/CustomIcons/QuestionIcon/web";

const { NODE_ENV } = getConfig().publicRuntimeConfig;

const { useBreakpoint } = Grid;

const { Text } = Typography;

export const ScheduleVisitForm = ({
	id,
	onComplete = null,
	form,
	identifier = 1,
	mode,
	disabled = false,
	isInListing = false,
	isProjectSpecialPage = false,
	slug = "",
	projectId = null,
	isFromPaidTraffic = null,
	isProject = false
}) => {
	const screens = useBreakpoint();
	const Router = useRouter();
	const [show, setShow] = useState(false);

	const {
		sendContact,
		resetForm,
		formCompleted,
		loading,
		disabledEmail,
		dataRegisterMutation,
		doContactMutation,
		dataUserExist,
		updateUser,
		isSendedConsultation
	} = useContact({
		id,
		onComplete,
		type: "schedule",
		mode,
		source: isInListing ? 22 : screens.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const { user } = useUser();
	const { country_code } = useContext(ConfigStateContext);
	// const GA = useGoogleAnalytics();
	const FP = useFacebookPixel();

	const [selectedDate, setSelectedDate] = useState(null);
	useEffect(() => form.setFieldsValue({ date: selectedDate }), [selectedDate]);

	const reset = () => {
		resetForm();
		form.resetFields();
	};

	useEffect(() => {
		Router.events.on("routeChangeStart", reset);
		return () => Router.events.on("routeChangeStart", reset);
	}, []);

	useEffect(() => {
		if (user.data && !formCompleted) {
			form.setFieldsValue({
				nombre: user?.data?.me?.name,
				telefono: user?.data?.me?.phone,
				email: user?.data?.me?.email,
			});
		}
	}, [user]);

	useEffect(() => {
		if (formCompleted) {
			const categoryName: string = "formulario";

			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (dataUserExist) {
			openAuthModal({ withPromise: true, email: form.getFieldsValue().email })
				.then(({ data }) => {
					updateUser({
						name: form.getFieldsValue().name,
						phone: form.getFieldsValue().phone,
					}).then(data => {
						doContactMutation();
					});
				})
				.catch(error => {
					//if(onComplete) onComplete();
				});
		}
	}, [dataUserExist]);

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, { expires: 365 });
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const validateMessages = {
		required: "El ${label} es requerido!",
		types: {
			email: "El ${label} no es válido!",
			number: "El ${label} no es un número válido!",
		},
	};

	const validateRules: { [x: string]: Rule[] } = {
		nombre: [{ required: true }],
		telefono: [
			{
				required: true,
				pattern: new RegExp("^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$"),
				message: "Teléfono no válido",
			},
		],
		email: [{ required: true, type: "email" }],
	};

	const submitForm = () => {
		form.validateFields()
			.then(values => {
				values.isFromPaidTraffic = isFromPaidTraffic;
				values.isCoordinatingVisit = true;

				sendContact(values);

				if (isProjectSpecialPage && slug && projectId) {
					let host = window.location.host;
					let TEST_HOST = "xn--4v8h.infocasas.com.uy";
					if (host === TEST_HOST || host === "localhost:3000") {
						host = "beta.infocasas.com.uy";
					}
					const msj = `Me gustaría agendar una visita ${values.visit_type
						}. Tengo disponibilidad el: ${dayjs(values.date).format("DD/MM/YYYY")}`;
					let reqEndpoint = `https://${host}/?mid=proyectos&func=landingDinamica&slug=${slug}&formulario&IDproyecto=${projectId}&json&nl`;
					let body = {
						nombre: values.nombre,
						email: values.email,
						tel: values.telefono,
						extra: msj,
						extra_completo: `${msj}.slug:${slug}`,
						InfoLeads: 1,
					};

					fetch(reqEndpoint, {
						method: "POST",
						body: JSON.stringify(body),
					}).then(res => {
						//
					});
				}
			})
			.catch(info => console.log("Validate Failed:", info));
	};

	const handleShowModal = () => {
		setShow(!show)
	}

	return (
		<>
			<Form
				form={form}
				name={"leadForm_" + identifier}
				initialValues={{
					nombre: user.data?.me?.name,
					telefono: user.data?.me?.phone,
					email: user.data?.me?.email,
					visit_type: "VIRTUAL",
					date: selectedDate,
				}}
				labelCol={{ span: 0 }}
				scrollToFirstError
				validateMessages={validateMessages}>
				<Form.Item
					labelCol={{ span: 24 }}
					name="visit_type"
					label={
						<Space>
							<Text type={"secondary"}>{"Tipo de Visita"}</Text>
							<Popover
								placement={!screens.lg ? "bottom" : "top"}
								overlayClassName={"note-popover"}
								content={"visit_type_note"}>
								<QuestionCircleOutlined />
							</Popover>
						</Space>
					}>
					<Radio.Group buttonStyle="solid" className={"visit-type-radio"}>
						<Radio.Button value="INPERSON" disabled={disabled}>
							{"En Persona"}
						</Radio.Button>
						<Radio.Button value="VIRTUAL" disabled={disabled}>
							{"Virtual"}
						</Radio.Button>
					</Radio.Group>
				</Form.Item>
				<Form.Item name="date" label={"Fecha"} style={{ display: "none" }}>
					<Input />
				</Form.Item>
				<Form.Item>
					<DateSelector
						selected={selectedDate}
						onSelect={setSelectedDate}
						disabled={disabled}
					/>
				</Form.Item>
				<Row gutter={12}>
					<Col span={12}>
						<Form.Item
							name="nombre"
							label={"Nombre"}
							hasFeedback
							rules={validateRules.nombre}>
							<Input
								className="secondary"
								placeholder={"Nombre"}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item name="telefono" label={"Telefono"} rules={validateRules.telefono}>
							<Input
								className="secondary"
								placeholder={"Teléfono"}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item name="email" label={"Email"} hasFeedback rules={validateRules.email}>
					<Input
						disabled={disabledEmail || disabled}
						className="secondary"
						placeholder={"Email"}
					/>
				</Form.Item>

				{country_code !== "BR" && !isProject && (
					<div className="container-busca-por-ti">
						<Form.Item name="busca_por_ti" valuePropName="checked" className="container-busca-por-ti">
							<Checkbox disabled={disabled}>
								{"Quiero que InfoCasas busque por mí"}
							</Checkbox>
						</Form.Item>

						<button onClick={handleShowModal} className="info-btn">
							<QuestionIcon width={20} height={20} />
						</button>
					</div>
				)}

				<Form.Item>
					<LeadButtons id={id} mode={mode} disabled={disabled}>
						<Button
							type="primary"
							loading={loading}
							disabled={formCompleted || disabled || isSendedConsultation.coordinateVisit}
							className="btn-send-lead"
							id="btn-send-lead"
							onClick={submitForm}>
							{formCompleted
								? "Enviado"
								: loading
									? "Enviando"
									: "Coordinar Visita"}
						</Button>
					</LeadButtons>
				</Form.Item>
			</Form>

			{show && <IcBuscaPorTi onClose={handleShowModal} showButtons={false} />}
		</>
	);
};

